import $ from 'jquery'

import '@search/js/utils/form-select.js'

window.$ = $

$(document).ready(function () {

    let $textarea = $('textarea.autoheight')
    $textarea.keydown(function() {
      let el = $(this).get()[0]
      setTimeout(function() {
        $(el).css('height', el.scrollHeight + 'px')
      }, 0)
    })
    //$('.form-select').each(function() {
    //  new FormSelect(this);
    //});

    $('.card-staff:not(.horizontal)').on('click', function(){
      window.location.href = $(this).data('href')
    })
});



// WEBPACK FOOTER //
// ./staff/static/staff/js/apps.js